
//Tally counter in the footer of homepage
if ( $('#tally').length ) {
	var inview = new Waypoint.Inview({

		  element: $('#tally')[0],
		  enter: function(direction) {

		    $('.count').each(function () {
		      $(this).prop('Counter',0).animate({
		        Counter: $(this).text()
		      }, {
		        duration: 4000,
		        easing: 'swing',
		        step: function (now) {
		          $(this).text(Math.ceil(now));
		        }
		      });
		    });
		    this.destroy();
		  }
	})
}



// WEBPACK FOOTER //
// ./src/js/tallyCounter.js